import { HTTP } from "@/utils/http-common";

const BASE = "/business/admin/announcements";

export default {
  async list(params = {}) {
    const response = await HTTP.get(BASE, { params });
    return response.data;
  },

  async create(data) {
    const response = await HTTP.post(BASE, data);
    return response.data;
  },

  async update(id, data) {
    const response = await HTTP.patch(`${BASE}/${id}`, data);
    return response.data;
  },

  async remove(id) {
    const response = await HTTP.delete(`${BASE}/${id}`);
    return response.data;
  },
};
